enum ImageOrigin {
  FACETEC = 'Facetec',
  MEUTUDO = 'Sorriso',
  BACKOFFICE_MEUTUDO = 'Meutudo',
}

export default ImageOrigin;
